import { countryValidationData } from "./Helpers";

// global regex
const noHtmlRegex = /<\/?[^>]+(>|$)/g;
const onlyAlphbetRegex = /^[a-zA-Z ]*$/;
const regNum = /[^a-zA-Z0-9 ]/;
const numberOnly = /^\d+$/;
var phoneRegex = /^[0-9]+$/;
var numFeild = /^[+-]?\d+$/;
// var passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{7,}$/;
var passwordRegex =
  /^(?=.*[!@#$%^&*()_+\-=\[\]{}|;:,.<>?])(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[^\s]{8,32}$/;

const urlRegex = /^(https?):\/\/[^\s$.?#].[^\s]*$/;
const regex =
  /^([0][1-9]|[1][0-9]|[2][0-9]|[3][0-7])[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}Z[A-Z\d]{1}$/;

// const { dictionary } = useContext(LanguageContext);
// console.log(messages);
// const oneAlphabetRegex = /[A-Za-z]/;
const oneAlphabetRegex = /\p{L}/u;
let invalidText = "Character limit exceeded. Limit: 50 characters";
let feildCannot = "Field cannot be left blank";
let letterRequired = "At least one letter is required";
const checkEmail = (value) => {
  if (
    !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      value
    )
  ) {
    return true;
  } else if (
    value.includes('"') ||
    value.includes("'") ||
    value.includes(",") ||
    value.includes(" ")
  ) {
    return true;
  } else {
    return false;
  }
};

export const loginValidator = (values) => {
  let errors = {};
  if (!values.email) {
    errors.email = "This is an error message.";
  } else if (checkEmail(values.email)) {
    errors.email = "Invalid Email";
  }
  if (!values.password) {
    errors.password = "This is an error message.";
  }
  return errors;
};
export const forgotValidator = (values) => {
  let errors = {};
  if (!values.email) {
    errors.email = "Enter Email";
  } else if (checkEmail(values.email)) {
    errors.email = "Invalid Email";
  }
  return errors;
};
export const resetValidator = (values, lang) => {
  let errors = {};
  if (!values.password) {
    errors.password = "Enter Password";
  } else if (values.password.length < 8) {
    errors.password = "Invalid Password";
  } else if (!passwordRegex.test(values.password)) {
    errors.password = "Invalid Password";
  }
  if (!values.confirm_password) {
    errors.confirm_password = "Enter Confirm Password";
  } else if (values.password !== values.confirm_password) {
    errors.confirm_password = "Password does not match";
  }
  return errors;
};
export const signUpValidator = (values) => {
  let errors = {};
  if (!values.email) {
    errors.email = "Enter Email";
  } else if (checkEmail(values.email)) {
    errors.email = "Invalid Email";
  }
  if (!values.password) {
    errors.password = "Enter Password";
  } else if (values.password.length < 8) {
    errors.password = "Password Should be 8 characters";
  }
  if (!values.confirm_password) {
    errors.confirm_password = "Enter Confirm Password";
  } else if (values.password !== values.confirm_password) {
    errors.confirm_password = "Password doesnot match with password";
  }
  return errors;
};
export const otpValidator = (values) => {
  let errors = {};
  if (!values.otp) {
    errors.otp = "Enter OTP";
  } else if (values.otp.length < 4) {
    errors.otp = "Invalid OTP";
  }
  return errors;
};
export const getOtpValidator = (values) => {
  let errors = {};
  if (!values.mobile) {
    errors.mobile = "Enter Mobile Number";
  }
  return errors;
};
export const groupValidator = (values) => {
  let errors = {};
  if (!values.title) {
    errors.title = "Enter Title";
  }
  return errors;
};
export const addUserValidator = (values, lang) => {
  let errors = {};
  console.log(values, "Error");
  if (!values.username) {
    errors.username = "Enter Username";
  } else if (!oneAlphabetRegex?.test(values.username)) {
    errors.username = letterRequired;
  }
  if (!values.firstName) {
    errors.firstName = "Enter First Name";
  } else if (!oneAlphabetRegex?.test(values.firstName)) {
    errors.firstName = letterRequired;
  }
  if (!values.lastName) {
    errors.lastName = "Enter Last Name";
  } else if (!oneAlphabetRegex?.test(values.lastName)) {
    errors.lastName = letterRequired;
  }
  if (!values.phoneNumber) {
    errors.phoneNumber = "Enter Mobile Number";
  } else if (values.phoneNumber?.length > 1) {
    if (values.phoneNumber?.length < 4) {
      errors.phoneNumber = "Invalid Mobile Number";
    }
  }
  if (!values.password) {
    errors.password = "Enter Password";
  } else if (values.password.length < 8) {
    errors.password = "Invalid Password";
  } else if (!passwordRegex.test(values.password)) {
    errors.password = "Invalid Password";
  }
  if (!values.confirm_password) {
    errors.confirm_password = "Enter Confirm Password";
  } else if (values.password !== values.confirm_password) {
    errors.confirm_password = "Password does not match";
  }
  if (!values.email) {
    errors.email = "Enter Email";
  } else if (checkEmail(values.email)) {
    errors.email = "Invalid Email";
  }
  return errors;
};
export const categoryValidator = (values) => {
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  // if (!values.description) {
  //   errors.description = "Enter Description";
  // }
  if (values.description?.length > 2000) {
    errors.description = "Character limit exceeded. Limit: 2000 characters";
  }
  return errors;
};
export const notesValidator = (values) => {
  let errors = {};
  if (values.description?.length > 1100) {
    errors.description = "Character limit exceeded. Limit: 1000 characters";
  }
  return errors;
};
export const reminderValidator = (values) => {
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (!values.schedule_type) {
    errors.schedule_type = feildCannot;
  }
  if (!values.send_reminder_as) {
    errors.send_reminder_as = feildCannot;
  }
  if (values.send_reminder_as === "email") {
    // if (values.groupId?.length === 0) {
    //   errors.groupId = feildCannot;
    // }
    if (!values.subject) {
      errors.subject = feildCannot;
    }
  }
  if (values.send_reminder_as === "notification") {
    if (values.notificationType !== "sms") {
      if (!values.notificationTitle) {
        errors.notificationTitle = feildCannot;
      }
    }

    if (!values.notificationType) {
      errors.notificationType = feildCannot;
    }
  }
  if (
    values.send_reminder_as === "notification" ||
    values.send_reminder_as === "email"
  ) {
    if (!values.body) {
      errors.body = feildCannot;
    }
  }

  console.log(errors, "errors errors");
  return errors;
};
// export const reportSheduleValidator = (values) => {
//   let errors = {};
//   if (!values.title) {
//     errors.title = feildCannot;
//   } else if (values.title?.length > 50) {
//     errors.title = invalidText;
//   } else if (!oneAlphabetRegex?.test(values.title)) {
//     errors.title = letterRequired;
//   }
//   if (!values.clientIds) {
//     errors.clientIds = feildCannot;
//   }
//   if (!values.categories) {
//     errors.categories = feildCannot;
//   }
//   if (!values.courseIds) {
//     errors.courseIds = feildCannot;
//   }
//   if (!values.startDate) {
//     errors.startDate = feildCannot;
//   }
//   if (!values.endDate) {
//     errors.endDate = feildCannot;
//   }
//   if (!values.status) {
//     errors.status = feildCannot;
//   }
//   if (!values.schedule_type) {
//     errors.schedule_type = feildCannot;
//   }
//   if (!values.body) {
//     errors.body = feildCannot;
//   }
//   if (!values.subject) {
//     errors.subject = feildCannot;
//   }
//   console.log(errors, "errors errors");
//   return errors;
// };

export const reportSheduleValidator = (values) => {
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  }
  if (!values.schedule_type) {
    errors.schedule_type = feildCannot;
  }
  if (!values.body) {
    errors.body = feildCannot;
  }
  return errors;
};

export const sheduleValidator = (values) => {
  let errors = {};
  if (!values.start_date) {
    errors.start_date = feildCannot;
  }
  if (!values.count) {
    errors.count = feildCannot;
  }
  if (!values.schedule_type) {
    errors.schedule_type = feildCannot;
  }
  if (values.schedule_type === "weekly") {
    if (!values.week_day) {
      errors.week_day = feildCannot;
    }
  }
  if (values.schedule_type === "monthly") {
    if (!values.monthly_type) {
      errors.monthly_type = "Select Monthly Type";
    } else if (values.monthly_type === "onDay") {
      if (!values.onDay) {
        errors.onDay = feildCannot;
      }
      if (values.onDay > 31) {
        errors.onDay = "Invalid On Day";
      }
    } else if (values.monthly_type === "custom") {
      if (!values.week_day) {
        errors.week_day = feildCannot;
      }
      if (!values.week_type) {
        errors.week_type = feildCannot;
      }
    }
  }
  if (values.schedule_type === "yearly") {
    if (!values.year_type) {
      errors.year_type = "Select Yearly Type";
    } else if (values.year_type === "custom") {
      if (!values.onDay) {
        errors.onDay = feildCannot;
      }
      if (!values.month) {
        errors.month = feildCannot;
      }
    } else if (values.year_type === "schedule") {
      if (!values.week_day) {
        errors.week_day = feildCannot;
      }
      if (!values.week_type) {
        errors.week_type = feildCannot;
      }
      if (!values.month_two) {
        errors.month_two = feildCannot;
      }
    }
  }
  if (!values.end_date) {
    errors.end_date = feildCannot;
  }
  return errors;
};
export const bannerValidator = (values) => {
  let errors = {};
  if (!values.bannerName) {
    errors.bannerName = feildCannot;
  } else if (values.bannerName?.length > 50) {
    errors.bannerName = invalidText;
  } else if (!oneAlphabetRegex?.test(values.bannerName)) {
    errors.bannerName = letterRequired;
  }
  if (values.bannerLink) {
    if (!urlRegex.test(values.bannerLink)) {
      errors.bannerLink = "Invalid Banner Link";
    } else if (values.bannerLink?.length > 200) {
      errors.bannerLink = invalidText;
    }
  }
  if (!values.startDate) {
    errors.startDate = feildCannot;
  }
  if (!values.endDate) {
    errors.endDate = feildCannot;
  }
  if (!values.startTime) {
    errors.startTime = feildCannot;
  }
  if (!values.endTime) {
    errors.endTime = feildCannot;
  }
  if (values.showTextStatus) {
    if (!values.showText) {
      errors.showText = feildCannot;
    }
  }
  return errors;
};
export const langValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (values.applicationLevel) {
    if (!values.fileUrl) {
      errors.fileUrl = feildCannot;
    }
  }
  // if (!values.description) {
  //   errors.description = feildCannot;
  // }
  if (values.description?.length > 250) {
    errors.description = "Character limit exceeded. Limit: 250 characters";
  }
  return errors;
};
export const courseReportsValidator = (values) => {
  console.log(values, "courseReportsValidator");
  let errors = {};
  if (values.clientIds?.length === 0) {
    errors.clientIds = feildCannot;
  }
  if (values.categories?.length === 0) {
    errors.categories = feildCannot;
  }
  if (values.courseIds?.length === 0) {
    errors.courseIds = feildCannot;
  }
  if (values.city?.length === 0) {
    errors.city = feildCannot;
  }
  if (!values.status) {
    errors.status = feildCannot;
  }
  if (!values.startDate) {
    errors.startDate = feildCannot;
  }
  if (!values.endDate) {
    errors.endDate = feildCannot;
  }
  return errors;
};
export const badgeValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (!values.badgeType) {
    errors.badgeType = feildCannot;
  }
  if (values.badgeType === 2) {
    if (!values.level) {
      errors.level = feildCannot;
    }
  }
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (!values.description) {
    errors.description = feildCannot;
  }
  if (!values.logoImage) {
    errors.logoImage = feildCannot;
  }
  return errors;
};
export const musicValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (!values.url) {
    errors.url = feildCannot;
  }

  return errors;
};
export const roleValidator = (values) => {
  console.log(values, "values values");
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (values.description?.length > 500) {
    errors.description = "Character limit exceeded. Limit: 500 characters";
  }
  // if (values.permissionsIds?.length === 0) {
  //   errors.permissionsIds = feildCannot;
  // }
  console.log(errors, " role valid");
  return errors;
};
export const configValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (values.learnerCertificateToggle) {
    if (!values.learnerCertificateId) {
      errors.learnerCertificateId = feildCannot;
    }
  }
  if (values.languageToggle) {
    if (!values.languageId) {
      errors.languageId = feildCannot;
    }
  }
  // if (values.quizRetakes) {
  //   if (!values.retakes) {
  //     errors.retakes = feildCannot;
  //   }
  // }
  if (values.rainLogoToggle) {
    if (!values.rainmakerLogoUrl) {
      errors.rainmakerLogoUrl = feildCannot;
    }
  }
  if (values.rainSignatoryToggle) {
    if (!values.rainmakerSignatoryUrl) {
      errors.rainmakerSignatoryUrl = feildCannot;
    }
  }
  console.log(errors, " role valid");
  return errors;
};
export const userValidator = (values) => {
  let errors = {};
  if (!values.firstName) {
    errors.firstName = feildCannot;
  } else if (values.firstName?.length > 50) {
    errors.firstName = invalidText;
  } else if (!oneAlphabetRegex?.test(values.firstName)) {
    errors.firstName = letterRequired;
  }
  if (!values.lastName) {
    errors.lastName = feildCannot;
  } else if (values.lastName?.length > 50) {
    errors.lastName = invalidText;
  } else if (!oneAlphabetRegex?.test(values.lastName)) {
    errors.lastName = letterRequired;
  }
  if (!values.email) {
    errors.email = feildCannot;
  } else if (checkEmail(values.email)) {
    errors.email = "Invalid Email";
  }
  if (values.email?.length > 50) {
    errors.email = invalidText;
  }
  // if (!values.phoneNumber) {
  //   errors.phoneNumber = feildCannot;
  // }
  if (values.countryCode && values.phoneNumber) {
    // Find country data based on countryCode
    const countryData = countryValidationData?.find(
      (country) => country.dialCode === values.countryCode
    );

    if (countryData) {
      // Validate the length of the mobile number
      if (values.phoneNumber?.length !== countryData?.length) {
        errors.phoneNumber = `Invalid Mobile Number. It should be ${countryData.length} digits for ${countryData.country}.`;
      }
    }
  }
  if (!values._id) {
    if (!values.password) {
      errors.password = feildCannot;
    } else if (values.password.length < 8) {
      errors.password =
        "Password must contain 8 characters, at least one uppercase letter, one lowercase letter, one number and one special character";
    } else if (values.password.length > 50) {
      errors.password = invalidText;
    } else if (!passwordRegex.test(values.password)) {
      errors.password = "Invalid Password";
    }
    if (!values.confirmPassword) {
      errors.confirmPassword = feildCannot;
    } else if (values.password !== values.confirmPassword) {
      errors.confirmPassword = "Password does not match";
    }
  }
  // if (!values.department) {
  //   errors.department = feildCannot;
  // }
  // if (!values.designation) {
  //   errors.designation = feildCannot;
  // }
  if (!values.rmUserType) {
    errors.rmUserType = feildCannot;
  }
  if (values.groupIds?.length === 0) {
    errors.groupIds = feildCannot;
  }
  console.log(errors, " errors errorserrorserrors");
  return errors;
};
export const courseValidator = (values) => {
  let errors = {};
  if (!values.categories) {
    errors.categories = feildCannot;
  }
  if (!values.description) {
    errors.description = feildCannot;
  } else if (values.description.replace(/<[^>]+>/g, "") > 342) {
    errors.description = "Word limit exceeded";
  }
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (!values.url) {
    errors.url = feildCannot;
  }
  return errors;
};
export const documentValidator = (values) => {
  let errors = {};
  if (!values.categories) {
    errors.categories = feildCannot;
  }
  
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (!values.url) {
    errors.url = feildCannot;
  }
  return errors;
};
export const courseValidatore = (values) => {
  let errors = {};
  if (!values.categories) {
    errors.categories = feildCannot;
  }
  if (!values.courseTitle) {
    errors.courseTitle = feildCannot;
  } else if (values.courseTitle?.length > 50) {
    errors.courseTitle = invalidText;
  } else if (!oneAlphabetRegex?.test(values.courseTitle)) {
    errors.courseTitle = letterRequired;
  }
  if (!values.certificateText) {
    errors.certificateText = feildCannot;
  }
  if (values.certificateText?.length > 500) {
    errors.certificateText = "Character limit exceeded. Limit: 500 characters";
  }
  if (values.language?.length === 0) {
    errors.language = feildCannot;
  }
  return errors;
};
export const quizzValidator = (values) => {
  // console.log(values, "error");
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (!values.categorieId) {
    errors.categorieId = feildCannot;
  }
  if (!values.courseId) {
    errors.courseId = feildCannot;
  }
  if (!values.languageId) {
    errors.languageId = feildCannot;
  }
  if (!values.episodeId) {
    errors.episodeId = feildCannot;
  }
  if (!values.passingPercentage) {
    errors.passingPercentage = feildCannot;
  }
  if (values.passingPercentage < 0 || values.passingPercentage > 100) {
    errors.passingPercentage = "Enter number between 0 to 100";
  }
  if (values.isRetake) {
    if (!values.allowTake) {
      errors.allowTake = feildCannot;
    }
  }
  return errors;
};
export const quizzFreeValidator = (values) => {
  // console.log(values, "error");
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (!values.categorieId) {
    errors.categorieId = feildCannot;
  }
  if (!values.courseId) {
    errors.courseId = feildCannot;
  }
  if (!values.languageId) {
    errors.languageId = feildCannot;
  }
  if (!values.passingPercentage) {
    errors.passingPercentage = feildCannot;
  }
  if (values.passingPercentage <= 0 || values.passingPercentage >= 100) {
    errors.passingPercentage = "Enter number between 1 to 99";
  }
  return errors;
};
export const interQuizzValidator = (values) => {
  console.log(values, "error");
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (!values.categorieId) {
    errors.categorieId = feildCannot;
  }
  if (!values.courseId) {
    errors.courseId = feildCannot;
  }
  if (!values.languageId) {
    errors.languageId = feildCannot;
  }
  if (!values.episodeId) {
    errors.episodeId = feildCannot;
  }
  console.log(errors, "error");
  return errors;
};
export const courseLangValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  values.formValue.forEach((course, courseIndex) => {
    let courseErrors = {};
    if (!course.translateCategory) {
      courseErrors.translateCategory = feildCannot;
    } else if (course.translateCategory?.length > 50) {
      courseErrors.translateCategory = invalidText;
    } else if (!oneAlphabetRegex?.test(course.translateCategory)) {
      courseErrors.translateCategory = letterRequired;
    }
    if (!course.translateCourseName) {
      courseErrors.translateCourseName = feildCannot;
    } else if (course.translateCourseName?.length > 50) {
      courseErrors.translateCourseName = invalidText;
    } else if (!oneAlphabetRegex?.test(course.translateCourseName)) {
      courseErrors.translateCourseName = letterRequired;
    }
    if (!course.baiseDescription) {
      courseErrors.baiseDescription = feildCannot;
    }
    if (course.baiseDescription?.length > 2000) {
      courseErrors.baiseDescription =
        "Character limit exceeded. Limit: 2000 characters";
    }
    if (course.trailers?.length === 0) {
      courseErrors.trailers = feildCannot;
    }
    if (!course.thumbnailImage) {
      courseErrors.thumbnailImage = feildCannot;
    }
    if (!course.logoImage) {
      courseErrors.logoImage = feildCannot;
    }
    if (course.courseEpisodes?.length === 0) {
      courseErrors.courseEpisodes = feildCannot;
    }
    if (!course.feedbackFormId) {
      courseErrors.feedbackFormId = feildCannot;
    }
    if (course.isBasic) {
      // Validate episode name
      if (!course.translateCategory) {
        courseErrors.translateCategory = feildCannot;
      } else if (course.translateCategory?.length > 50) {
        courseErrors.translateCategory = invalidText;
      } else if (!oneAlphabetRegex?.test(course.translateCategory)) {
        courseErrors.translateCategory = letterRequired;
      }
      if (!course.translateCourseName) {
        courseErrors.translateCourseName = feildCannot;
      } else if (course.translateCourseName?.length > 50) {
        courseErrors.translateCourseName = invalidText;
      } else if (!oneAlphabetRegex?.test(course.translateCourseName)) {
        courseErrors.translateCourseName = letterRequired;
      }
      if (!course.baiseDescription) {
        courseErrors.baiseDescription = feildCannot;
      }
      if (course.baiseDescription?.length > 2000) {
        courseErrors.baiseDescription =
          "Character limit exceeded. Limit: 2000 characters";
      }
      if (course.trailers?.length === 0) {
        courseErrors.trailers = feildCannot;
      }
      if (!course.thumbnailImage) {
        courseErrors.thumbnailImage = feildCannot;
      }
      if (!course.logoImage) {
        courseErrors.logoImage = feildCannot;
      }

      // If there are any errors for the course, add them to the errors object.
      if (Object.keys(courseErrors).length > 0) {
        if (!errors.formValue) {
          errors.formValue = []; // Initialize formValue array in errors object if not already initialized
        }
        errors.formValue[courseIndex] = courseErrors;
      }
    }
    if (course.isCourse && !course.isAddButton) {
      // Validate episode name
      if (!course.courseEpisodeeName) {
        courseErrors.courseEpisodeeName = feildCannot;
      } else if (course.courseEpisodeeName?.length > 50) {
        courseErrors.courseEpisodeeName = invalidText;
      } else if (!oneAlphabetRegex?.test(course.courseEpisodeeName)) {
        courseErrors.courseEpisodeeName = letterRequired;
      }
      if (course.courseTags?.length === 0) {
        courseErrors.courseTags = feildCannot;
      }
      if (!course.courseDescription) {
        courseErrors.courseDescription = feildCannot;
      }
      if (course.courseDescription.length > 2000) {
        courseErrors.courseDescription =
          "Character limit exceeded. Limit: 2000 characters";
      }
      if (course.courseEpisodes?.length === 0) {
        courseErrors.courseEpisodes = feildCannot;
      }
      if (!course.url) {
        courseErrors.courseEpisodes = feildCannot;
      }

      // If there are any errors for the course, add them to the errors object.
      if (Object.keys(courseErrors)?.length > 0) {
        if (!errors.formValue) {
          errors.formValue = []; // Initialize formValue array in errors object if not already initialized
        }
        errors.formValue[courseIndex] = courseErrors;
      }
    }
    if (course.isFeedback) {
      // Validate episode name
      if (!course.feedbackFormId) {
        courseErrors.feedbackFormId = feildCannot;
      }

      // If there are any errors for the course, add them to the errors object.
      if (Object.keys(courseErrors).length > 0) {
        if (!errors.formValue) {
          errors.formValue = []; // Initialize formValue array in errors object if not already initialized
        }
        errors.formValue[courseIndex] = courseErrors;
      }
    }
  });

  console.log(errors, "errors");
  return errors;
};
export const quizzLangValidator = (values) => {
  console.log(values, "quizzLangValidator");
  let errors = {};

  values.formValue.forEach((course, courseIndex) => {
    let courseErrors = {};
    if (course.isAdd) {
      course?.questions?.forEach((question, questionIndex) => {
        let questionErrors = {};

        // Validate questionTitle
        if (!question.questionTitle) {
          questionErrors.questionTitle = `Field cannot be left blank`;
        } else if (!oneAlphabetRegex?.test(question.questionTitle)) {
          questionErrors.questionTitle = letterRequired;
        } else if (question.questionValues?.length < 2) {
          questionErrors.questionTitle = `Question should have minimum 2 options`;
        } else if (course?.questions?.length < 1) {
          questionErrors.questionTitle = `Minimum 1 question is required`;
        }
        // Validate inner items (questionValues)
        question?.questionValues?.forEach((value, valueIndex) => {
          if (!value.title) {
            if (!questionErrors.questionValues) {
              questionErrors.questionValues = [];
            }
            questionErrors.questionValues[valueIndex] = {
              title: `Field cannot be left blank`,
            };
          }
        });

        if (Object.keys(questionErrors).length > 0) {
          if (!courseErrors.questions) {
            courseErrors.questions = [];
          }
          courseErrors.questions[questionIndex] = questionErrors;
        }
      });
    }
    if (course.upload_questions) {
      course?.questions?.forEach((question, questionIndex) => {
        let questionErrors = {};

        // Validate questionTitle
        if (!question.questionTitle) {
          questionErrors.questionTitle = `Field cannot be left blank`;
        } else if (!oneAlphabetRegex?.test(question.questionTitle)) {
          questionErrors.questionTitle = letterRequired;
        } else if (question.questionValues?.length < 2) {
          questionErrors.questionTitle = `Question should have minimum 2 options`;
        }
        // Validate inner items (questionValues)
        question?.questionValues?.forEach((value, valueIndex) => {
          if (!value.title) {
            if (!questionErrors.questionValues) {
              questionErrors.questionValues = [];
            }
            questionErrors.questionValues[valueIndex] = {
              title: `Field cannot be left blank`,
            };
          }
        });

        if (Object.keys(questionErrors).length > 0) {
          if (!courseErrors.questions) {
            courseErrors.questions = [];
          }
          courseErrors.questions[questionIndex] = questionErrors;
        }
      });
    }
    if (Object.keys(courseErrors).length > 0) {
      if (!errors.formValue) {
        errors.formValue = [];
      }
      errors.formValue[courseIndex] = courseErrors;
    }
  });
  console.log(errors, "errors");

  return errors;
};
export const clientQuizzLangValidator = (values) => {
  let errors = {};

  if (values.questions?.length > 0) {
    let questionsErrors = []; // Use an array to store errors for each question

    values.questions.forEach((question, questionIndex) => {
      let questionErrors = {};

      // Validate questionTitle
      if (!question.question) {
        questionErrors.question = feildCannot;
      } else if (!oneAlphabetRegex?.test(question.question)) {
        questionErrors.question = letterRequired;
      } else if (question.answerOptions?.length < 2) {
        questionErrors.question = `Question should have minimum 2 options`;
      }

      // Validate inner items (answerOptions)
      if (question.answerOptions && question.answerOptions?.length > 0) {
        let answerOptionsErrors = [];
        question?.answerOptions?.forEach((value, valueIndex) => {
          let answerError = {};
          if (!value.option) {
            answerError.option = feildCannot;
            answerOptionsErrors[valueIndex] = answerError;
          }
        });

        if (answerOptionsErrors.length > 0) {
          questionErrors.answerOptions = answerOptionsErrors;
        }
      }

      // If there are any errors for this question, add to questionsErrors
      if (Object.keys(questionErrors)?.length > 0) {
        questionsErrors[questionIndex] = questionErrors;
      }
    });

    // If there are any questions errors, assign it to the errors object
    if (questionsErrors?.length > 0) {
      errors.questions = questionsErrors;
    }
  }

  console.log(errors); // Log to check what errors are being recorded
  return errors;
};
// export const clientQuizzInterLangValidator = (values) => {
//   let errors = {};

//   if (values.questions?.length > 0) {
//     let questionsErrors = []; // Use an array to store errors for each question

//     values.questions.forEach((question, questionIndex) => {
//       let questionErrors = {};

//       const minTimeNum = Number(question.minTime);
//       const secTimeNum = Number(question.secTime);
//       // Validate questionTitle
//       if (!question.question) {
//         questionErrors.question = feildCannot;
//       }
//       if (!question.question) {
//         questionErrors.question = feildCannot;
//       }
//       if (minTimeNum !== 0) {
//         const minutesNum = Number(question.minutes);
//         if (
//           isNaN(minutesNum) ||
//           minutesNum < 0 ||
//           minutesNum > 59 ||
//           !Number.isInteger(minutesNum)
//         ) {
//           questionErrors.minutes = "Invalid";
//         } else if (minutesNum > minTimeNum) {
//           questionErrors.minutes = `The entered timestamp exceeds the video's duration. Please enter a valid timestamp`;
//         }
//         // }
//       }

//       // Validate seconds
//       if (!question.seconds) {
//         questionErrors.seconds = "Required";
//       } else {
//         const secondsNum = Number(question.seconds);
//         if (
//           isNaN(secondsNum) ||
//           secondsNum < 0 ||
//           secondsNum > 59 ||
//           !Number.isInteger(secondsNum)
//         ) {
//           questionErrors.seconds = "Invalid";
//         } else {
//           // Only compare secondsNum to secTimeNum if minTimeNum is "00" or seconds validation is independent of minTimeNum
//           if (secTimeNum !== 0 && minTimeNum === 0) {
//             if (secondsNum > secTimeNum) {
//               questionErrors.seconds = `The entered timestamp exceeds the video's duration. Please enter a valid timestamp`;
//             }
//           }
//           // If you have additional conditions or logic for when secondsNum should not be compared to secTimeNum,
//           // include them in the above conditional statement.
//         }
//       }
//       if (questionIndex > 0) {
//         // Ensure there is a previous question to compare with
//         const prevQuestion = values.questions[questionIndex - 1];
//         const prevMinutes = Number(prevQuestion.minutes);
//         const prevSeconds = Number(prevQuestion.seconds);
//         const currentMinutes = Number(question.minutes);
//         const currentSeconds = Number(question.seconds);

//         // Comparing current question's time with the previous question's time
//         if (
//           currentMinutes === prevMinutes &&
//           currentSeconds === prevSeconds
//         ) {
//           questionErrors.minutes =
//             "Current question's time cannot be the same as the previous question's time.";
//         }
//       }

//       // Validate inner items (answerOptions)
//       if (question.answerOptions && question.answerOptions?.length > 0) {
//         let answerOptionsErrors = [];
//         question?.answerOptions?.forEach((value, valueIndex) => {
//           let answerError = {};
//           if (!value.option) {
//             answerError.option = feildCannot;
//             answerOptionsErrors[valueIndex] = answerError;
//           }
//         });

//         if (answerOptionsErrors.length > 0) {
//           questionErrors.answerOptions = answerOptionsErrors;
//         }
//       }

//       // If there are any errors for this question, add to questionsErrors
//       if (Object.keys(questionErrors)?.length > 0) {
//         questionsErrors[questionIndex] = questionErrors;
//       }
//     });

//     // If there are any questions errors, assign it to the errors object
//     if (questionsErrors?.length > 0) {
//       errors.questions = questionsErrors;
//     }
//   }

//   console.log(errors); // Log to check what errors are being recorded
//   return errors;
// };

export const interactiveQuizzLangValidator = (values) => {
  console.log(values, "quizzLangValidator");
  let errors = {};

  values.formValue.forEach((course, courseIndex) => {
    let courseErrors = {};
    const minTimeNum = Number(course.minTime);
    const secTimeNum = Number(course.secTime);
    if (course.isAdd) {
      course?.questions?.forEach((question, questionIndex) => {
        let questionErrors = {};

        // Validate questionTitle
        if (!question.questionTitle) {
          questionErrors.questionTitle = `Field cannot be left blank`;
        } else if (!oneAlphabetRegex?.test(question.questionTitle)) {
          questionErrors.questionTitle = letterRequired;
        } else if (question.questionValues?.length < 2) {
          questionErrors.questionTitle = `Question should have minimum 2 options`;
        }
        // else if (course?.questions?.length < 2) {
        //   questionErrors.questionTitle = `Minimum 2 questions required`;
        // }
        if (minTimeNum !== 0) {
          // Proceed with validation if minTime is not "00"
          // if (!question.minutes) {
          //   questionErrors.minutes = "Required";
          // } else {
          const minutesNum = Number(question.minutes);
          if (
            isNaN(minutesNum) ||
            minutesNum < 0 ||
            minutesNum > 59 ||
            !Number.isInteger(minutesNum)
          ) {
            questionErrors.minutes = "Invalid";
          } else if (minutesNum > minTimeNum) {
            questionErrors.minutes = `The entered timestamp exceeds the video's duration. Please enter a valid timestamp`;
          }
          // }
        }

        // Validate seconds
        if (!question.minutes) {
          if (!question.seconds) {
            questionErrors.seconds = "Required";
          }
        } else {
          const secondsNum = Number(question.seconds);
          if (
            isNaN(secondsNum) ||
            secondsNum < 0 ||
            secondsNum > 59 ||
            !Number.isInteger(secondsNum)
          ) {
            questionErrors.seconds = "Invalid";
          } else {
            // Only compare secondsNum to secTimeNum if minTimeNum is "00" or seconds validation is independent of minTimeNum
            if (secTimeNum !== 0 && minTimeNum === 0) {
              if (secondsNum > secTimeNum) {
                questionErrors.seconds = `The entered timestamp exceeds the video's duration. Please enter a valid timestamp`;
              }
            }
            // If you have additional conditions or logic for when secondsNum should not be compared to secTimeNum,
            // include them in the above conditional statement.
          }
        }
        if (questionIndex > 0) {
          // Ensure there is a previous question to compare with
          const prevQuestion = course.questions[questionIndex - 1];
          const prevMinutes = Number(prevQuestion.minutes);
          const prevSeconds = Number(prevQuestion.seconds);
          const currentMinutes = Number(question.minutes);
          const currentSeconds = Number(question.seconds);

          // Comparing current question's time with the previous question's time
          if (
            currentMinutes === prevMinutes &&
            currentSeconds === prevSeconds
          ) {
            questionErrors.minutes =
              "Current question's time cannot be the same as the previous question's time.";
          }
        }

        // Validate inner items (questionValues)
        question?.questionValues?.forEach((value, valueIndex) => {
          if (!value.title) {
            if (!questionErrors.questionValues) {
              questionErrors.questionValues = [];
            }
            questionErrors.questionValues[valueIndex] = {
              title: `Field cannot be left blank`,
            };
          }
        });

        if (Object.keys(questionErrors).length > 0) {
          if (!courseErrors.questions) {
            courseErrors.questions = [];
          }
          courseErrors.questions[questionIndex] = questionErrors;
        }
      });
    }
    if (course.upload_questions) {
      course?.questions?.forEach((question, questionIndex) => {
        let questionErrors = {};

        // Validate questionTitle
        if (!question.questionTitle) {
          questionErrors.questionTitle = `Field cannot be left blank`;
        }
        if (minTimeNum !== 0) {
          // Proceed with validation if minTime is not "00"

          const minutesNum = Number(question.minutes);
          if (
            isNaN(minutesNum) ||
            minutesNum < 0 ||
            minutesNum > 59 ||
            !Number.isInteger(minutesNum)
          ) {
            questionErrors.minutes = "Invalid";
          } else if (minutesNum > minTimeNum) {
            questionErrors.minutes = "Cannot be greater than episode minTime";
          }
        }

        // Validate seconds
        if (!question.seconds) {
          questionErrors.seconds = "Required";
        } else {
          const secondsNum = Number(question.seconds);
          if (
            isNaN(secondsNum) ||
            secondsNum < 0 ||
            secondsNum > 59 ||
            !Number.isInteger(secondsNum)
          ) {
            questionErrors.seconds = "Invalid";
          } else {
            // Only compare secondsNum to secTimeNum if minTimeNum is "00" or seconds validation is independent of minTimeNum
            if (secTimeNum !== 0 && minTimeNum === 0) {
              if (secondsNum > secTimeNum) {
                questionErrors.seconds =
                  "Cannot be greater than episode secTime";
              }
            }
            // If you have additional conditions or logic for when secondsNum should not be compared to secTimeNum,
            // include them in the above conditional statement.
          }
        }
        if (questionIndex > 0) {
          // Ensure there is a previous question to compare with
          const prevQuestion = course.questions[questionIndex - 1];
          const prevMinutes = Number(prevQuestion.minutes);
          const prevSeconds = Number(prevQuestion.seconds);
          const currentMinutes = Number(question.minutes);
          const currentSeconds = Number(question.seconds);

          // Comparing current question's time with the previous question's time
          if (
            currentMinutes === prevMinutes &&
            currentSeconds === prevSeconds
          ) {
            questionErrors.minutes =
              "Current question's time cannot be the same as the previous question's time.";
          }
        }
        // Validate inner items (questionValues)
        question?.questionValues?.forEach((value, valueIndex) => {
          if (!value.title) {
            if (!questionErrors.questionValues) {
              questionErrors.questionValues = [];
            }
            questionErrors.questionValues[valueIndex] = {
              title: `Field cannot be left blank`,
            };
          }
        });

        if (Object.keys(questionErrors).length > 0) {
          if (!courseErrors.questions) {
            courseErrors.questions = [];
          }
          courseErrors.questions[questionIndex] = questionErrors;
        }
      });
    }
    if (Object.keys(courseErrors).length > 0) {
      if (!errors.formValue) {
        errors.formValue = [];
      }
      errors.formValue[courseIndex] = courseErrors;
    }
  });
  console.log(errors, "errors interactiveQuizzLangValidator");
  return errors;
};
export const feedbackValidator = (values) => {
  let errors = {};
  if (!values.categories) {
    errors.categories = feildCannot;
  }
  if (!values.formName) {
    errors.formName = feildCannot;
  } else if (values.formName?.length > 50) {
    errors.formName = invalidText;
  } else if (!oneAlphabetRegex?.test(values.formName)) {
    errors.formName = letterRequired;
  }
  if (!values.languageId) {
    errors.languageId = feildCannot;
  }
  if (values.description?.length > 500) {
    errors.description = "Character limit exceeded. Limit: 500 characters";
  }
  values.questions.forEach((question, questionIndex) => {
    let questionErrors = {};
    // Validate episode name
    if (!question.questionTitle) {
      questionErrors.questionTitle = `Field cannot be left blank`;
    } else if (!oneAlphabetRegex?.test(question.questionTitle)) {
      questionErrors.questionTitle = letterRequired;
    }
    if (!question.questionType) {
      questionErrors.questionType = feildCannot;
    } else if (
      question.questionType === "single_choice" ||
      question.questionType === "multiple_choice"
    ) {
      if (question.questionValues?.length < 2) {
        questionErrors.questionTitle = `Question should have minimum 2 options.`;
      }
    }
    if (
      question.questionType === "single_choice" ||
      question.questionType === "rating" ||
      question.questionType === "multiple_choice"
    ) {
      let questionValuesErrors = [];
      question.questionValues.forEach((option, optionIndex) => {
        let optionErrors = {};
        if (!option.title) {
          optionErrors.title = `Field cannot be left blank`;
        }
        if (option.title?.length > 500) {
          optionErrors.title =
            "Character limit exceeded. Limit: 500 characters";
        }
        if (Object.keys(optionErrors).length > 0) {
          questionValuesErrors[optionIndex] = optionErrors;
        }
      });
      if (questionValuesErrors.length > 0) {
        questionErrors.questionValues = questionValuesErrors;
      }
    }

    // If there are any errors for the course, add them to the errors object.
    if (Object.keys(questionErrors).length > 0) {
      errors.questions = errors.questions || [];
      errors.questions[questionIndex] = questionErrors;
    }
  });
  return errors;
};
function validateSpoc(spoc, index, allSpocs) {
  let spocError = {};
  if (!spoc.firstName) {
    spocError.firstName = "This field cannot be empty";
  }
  if (!spoc.lastName) {
    spocError.lastName = "This field cannot be empty";
  }
  if (!spoc.emailId) {
    spocError.emailId = "This field cannot be empty";
  } else if (checkEmail(spoc.emailId)) {
    spocError.emailId = "Invalid Email";
  }
  if (!spoc.designation) {
    spocError.designation = "This field cannot be empty";
  }
  if (!spoc.mobileNumber) {
    spocError.mobileNumber = "This field cannot be empty";
  } else if (spoc.mobileNumber?.length > 1) {
    if (spoc.mobileNumber?.length < 4) {
      spocError.mobileNumber = "Invalid Mobile Number";
    }
  }
  if (!spoc.location) {
    spocError.location = "This field cannot be empty";
  }
  const duplicates = allSpocs?.filter(
    (s, idx) => s.firstName === spoc.firstName && idx !== index
  );
  if (duplicates.length > 0) {
    spocError.firstName = "Duplicate first name";
  }
  return spocError;
}
export const clientValidator = (values) => {
  console.log(values, "clientValidator");
  let errors = {};
  // if (!values.clientInformation?.clientInformationDetail?.parentEntity) {
  //   errors.clientInformation = errors.clientInformation || {};
  //   errors.clientInformation.clientInformationDetail =
  //     errors.clientInformation.clientInformationDetail || {};
  //   errors.clientInformation.clientInformationDetail.parentEntity = feildCannot;
  // }
  // if (!values.clientInformation?.clientInformationDetail?.parentEntity) {
  //   errors.clientInformation = errors.clientInformation || {};
  //   errors.clientInformation.clientInformationDetail =
  //     errors.clientInformation.clientInformationDetail || {};
  //   errors.clientInformation.clientInformationDetail.parentEntity = feildCannot;
  // } else if (
  //   !oneAlphabetRegex?.test(
  //     values.clientInformation.clientInformationDetail.parentEntity
  //   )
  // ) {
  //   errors.clientInformation = errors.clientInformation || {};
  //   errors.clientInformation.clientInformationDetail =
  //     errors.clientInformation.clientInformationDetail || {};
  //   errors.clientInformation.clientInformationDetail.parentEntity =
  //     letterRequired;
  // } else if (
  //   values.clientInformation.clientInformationDetail.parentEntity?.length > 50
  // ) {
  //   errors.clientInformation = errors.clientInformation || {};
  //   errors.clientInformation.clientInformationDetail =
  //     errors.clientInformation.clientInformationDetail || {};
  //   errors.clientInformation.clientInformationDetail.parentEntity = invalidText;
  // }
  if (!values.clientInformation?.clientInformationDetail?.legalEntityName) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.legalEntityName =
      feildCannot;
  } else if (
    !oneAlphabetRegex?.test(
      values.clientInformation.clientInformationDetail.legalEntityName
    )
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.legalEntityName =
      letterRequired;
  } else if (
    values.clientInformation.clientInformationDetail.legalEntityName?.length >
    50
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.legalEntityName =
      invalidText;
  }
  if(!values.clientInformation?.type_of_client){
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.type_of_client =
      feildCannot;
  }
  if (!values.clientInformation?.clientInformationDetail?.organizationName) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.organizationName =
      feildCannot;
  } else if (
    !oneAlphabetRegex?.test(
      values.clientInformation.clientInformationDetail.organizationName
    )
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.organizationName =
      letterRequired;
  } else if (
    values.clientInformation.clientInformationDetail.organizationName?.length >
    50
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.organizationName =
      invalidText;
  }
  if (!values.clientInformation?.clientInformationDetail?.industry) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.industry = feildCannot;
  }
  if (
    !values.clientInformation?.clientInformationDetail?.companyAddress
      ?.addressLineOne
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.companyAddress =
      errors.clientInformation.clientInformationDetail.companyAddress || {};
    errors.clientInformation.clientInformationDetail.companyAddress.addressLineOne =
      feildCannot;
  } else if (
    !oneAlphabetRegex?.test(
      values.clientInformation?.clientInformationDetail?.companyAddress
        ?.addressLineOne
    )
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.companyAddress =
      errors.clientInformation.clientInformationDetail.companyAddress || {};
    errors.clientInformation.clientInformationDetail.companyAddress.addressLineOne =
      letterRequired;
  } else if (
    values.clientInformation?.clientInformationDetail?.companyAddress
      ?.addressLineOne?.length > 50
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.companyAddress =
      errors.clientInformation.clientInformationDetail.companyAddress || {};
    errors.clientInformation.clientInformationDetail.companyAddress.addressLineOne =
      invalidText;
  }
  if (
    !values.clientInformation?.clientInformationDetail?.companyAddress
      ?.addressLineTwo
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.companyAddress =
      errors.clientInformation.clientInformationDetail.companyAddress || {};
    errors.clientInformation.clientInformationDetail.companyAddress.addressLineTwo =
      feildCannot;
  } else if (
    !oneAlphabetRegex?.test(
      values.clientInformation?.clientInformationDetail?.companyAddress
        ?.addressLineTwo
    )
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.companyAddress =
      errors.clientInformation.clientInformationDetail.companyAddress || {};
    errors.clientInformation.clientInformationDetail.companyAddress.addressLineTwo =
      letterRequired;
  } else if (
    values.clientInformation?.clientInformationDetail?.companyAddress
      ?.addressLineTwo?.length > 50
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.companyAddress =
      errors.clientInformation.clientInformationDetail.companyAddress || {};
    errors.clientInformation.clientInformationDetail.companyAddress.addressLineTwo =
      invalidText;
  }
  if (
    !values.clientInformation?.clientInformationDetail?.companyAddress?.country
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.companyAddress =
      errors.clientInformation.clientInformationDetail.companyAddress || {};
    errors.clientInformation.clientInformationDetail.companyAddress.country =
      feildCannot;
  }
  if (
    !values.clientInformation?.clientInformationDetail?.companyAddress?.pinCode
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.companyAddress =
      errors.clientInformation.clientInformationDetail.companyAddress || {};
    errors.clientInformation.clientInformationDetail.companyAddress.pinCode =
      feildCannot;
  } else if (
    values.clientInformation?.clientInformationDetail?.companyAddress?.pinCode
      ?.length < 6
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.companyAddress =
      errors.clientInformation.clientInformationDetail.companyAddress || {};
    errors.clientInformation.clientInformationDetail.companyAddress.pinCode =
      "Pincode does not meet the minimum length requirement";
  }
  if (
    !values.clientInformation?.clientInformationDetail?.companyAddress?.city
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.companyAddress =
      errors.clientInformation.clientInformationDetail.companyAddress || {};
    errors.clientInformation.clientInformationDetail.companyAddress.city =
      feildCannot;
  }
  if (
    !values.clientInformation?.clientInformationDetail?.companyAddress?.state
  ) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.clientInformationDetail =
      errors.clientInformation.clientInformationDetail || {};
    errors.clientInformation.clientInformationDetail.companyAddress =
      errors.clientInformation.clientInformationDetail.companyAddress || {};
    errors.clientInformation.clientInformationDetail.companyAddress.state =
      feildCannot;
  }
  // if (!values.clientInformation?.uploadLogo?.logoImage) {
  //   errors.clientInformation = errors.clientInformation || {};
  //   errors.clientInformation.uploadLogo =
  //     errors.clientInformation.uploadLogo || {};
  //   errors.clientInformation.uploadLogo.logoImage = feildCannot;
  // }
  // if (!values.clientInformation?.clientSigatoryUrl) {
  //   errors.clientInformation = errors.clientInformation || {};
  //   errors.clientInformation.clientSigatoryUrl =
  //     errors.clientInformation.clientSigatoryUrl || {};
  //   errors.clientInformation.clientSigatoryUrl = feildCannot;
  // }
  // if (!values.clientInformation?.RmSalesSpoc) {
  //   errors.clientInformation = errors.clientInformation || {};
  //   errors.clientInformation.RmSalesSpoc = feildCannot;
  // }
  // if (!values.clientInformation?.RmOperationSpoc) {
  //   errors.clientInformation = errors.clientInformation || {};
  //   errors.clientInformation.RmOperationSpoc = feildCannot;
  // }
  // if (
  //   values.clientInformation.ClientSpoc &&
  //   values.clientInformation.ClientSpoc?.length > 0
  // ) {
  //   let spocErrors = values.clientInformation.ClientSpoc?.map((spoc) => {
  //     let spocError = {};

  //     // Validate name
  //     if (!spoc.firstName) {
  //       spocError.firstName = feildCannot;
  //     }
  //     if (!spoc.lastName) {
  //       spocError.lastName = feildCannot;
  //     }
  //     if (!spoc.emailId) {
  //       spocError.emailId = "Enter Email-Id";
  //     } else if (checkEmail(spoc.emailId)) {
  //       spocError.emailId = "Invalid Email";
  //     }
  //     if (!spoc.designation) {
  //       spocError.designation = "Enter Designation";
  //     }
  //     if (!spoc.mobileNumber) {
  //       spocError.mobileNumber = "Enter Mobile Number";
  //     }
  //     if (spoc.mobileNumber?.toString()?.length > 10) {
  //       spocError.mobileNumber = "Invalid Mobile Number";
  //     }
  //     if (!spoc.location) {
  //       spocError.location = "Enter Location";
  //     }

  //     return spocError;
  //   });

  //   spocErrors = spocErrors.filter((error) => Object.keys(error).length > 0);

  //   if (spocErrors?.length > 0) {
  //     if (!errors.clientInformation) errors.clientInformation = {};
  //     errors.clientInformation.ClientSpoc = spocErrors;
  //   }
  // }
  // if (
  //   values.clientInformation.ClientSpoc &&
  //   values.clientInformation.ClientSpoc.length > 0
  // ) {
  //   const spocErrors = values.clientInformation.ClientSpoc?.map(
  //     (spoc, index, allSpocs) => validateSpoc(spoc, index, allSpocs)
  //   );
  //   if (spocErrors?.some((error) => Object?.keys(error).length > 0)) {
  //     errors.clientInformation = {
  //       ...errors.clientInformation,
  //       ClientSpoc: spocErrors,
  //     };
  //   }
  // }
  // if (
  //   values.clientInformation.ClientAdmin &&
  //   values.clientInformation.ClientAdmin.length > 0
  // ) {
  //   const adminErrors = values.clientInformation.ClientAdmin?.map(
  //     (admin, index, allAdmins) => validateSpoc(admin, index, allAdmins)
  //   );
  //   if (adminErrors?.some((error) => Object?.keys(error).length > 0)) {
  //     errors.clientInformation = {
  //       ...errors.clientInformation,
  //       ClientAdmin: adminErrors,
  //     };
  //   }
  // }
  // if (
  //   values.clientInformation.ClientAdmin &&
  //   values.clientInformation.ClientAdmin?.length > 0
  // ) {
  //   let spocErrors = values.clientInformation.ClientAdmin?.map((spoc) => {
  //     let spocError = {};

  //     // Validate name
  //     if (!spoc.firstName) {
  //       spocError.firstName = feildCannot;
  //     }
  //     if (!spoc.lastName) {
  //       spocError.lastName = feildCannot;
  //     }
  //     if (!spoc.emailId) {
  //       spocError.emailId = feildCannot;
  //     } else if (checkEmail(spoc.emailId)) {
  //       spocError.emailId = "Invalid Email";
  //     }
  //     if (!spoc.designation) {
  //       spocError.designation = feildCannot;
  //     }
  //     if (!spoc.mobileNumber) {
  //       spocError.mobileNumber = feildCannot;
  //     } else if (spoc.mobileNumber?.toString()?.length > 10) {
  //       spocError.mobileNumber = "Invalid Mobile Number";
  //     }
  //     if (!spoc.location) {
  //       spocError.location = feildCannot;
  //     }

  //     return spocError;
  //   });

  //   spocErrors = spocErrors.filter((error) => Object.keys(error).length > 0);

  //   if (spocErrors.length > 0) {
  //     if (!errors.clientInformation) errors.clientInformation = {};
  //     errors.clientInformation.ClientAdmin = spocErrors;
  //   }
  // }
  if (values.clientInformation?.groupIds?.length === 0) {
    errors.clientInformation = errors.clientInformation || {};
    errors.clientInformation.groupIds = feildCannot;
  }
  console.log(errors, "errors");
  return errors;
};
export const ClientBillingValidator = (values) => {
  let errors = {};
  if (!values.billingInformation?.billingName) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.billingName = feildCannot;
  } else if (!oneAlphabetRegex?.test(values.billingInformation?.billingName)) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.billingName = letterRequired;
  } else if (values.billingInformation?.billingName?.length > 50) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.billingName = invalidText;
  }
  // if (!values.billingInformation?.billingContact) {
  //   errors.billingInformation = errors.billingInformation || {};
  //   errors.billingInformation.billingContact = feildCannot;
  // }
  // else if (
  //   !oneAlphabetRegex?.test(values.billingInformation?.billingContact)
  // ) {
  //   errors.billingInformation = errors.billingInformation || {};
  //   errors.billingInformation.billingContact = letterRequired;
  // }
  if (values.billingInformation?.billingContact?.length > 50) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.billingContact = invalidText;
  }
  // if (values.billingInformation?.billingContact?.toString()?.length > 10) {
  //   errors.billingInformation = errors.billingInformation || {};
  //   errors.billingInformation.billingContact = "Invalid Billing Contact";
  // }
  // if (values.billingInformation?.billingContact?.length > 10) {
  //   errors.billingInformation = errors.billingInformation || {};
  //   errors.billingInformation.billingContact = "Invalid Billing Contact";
  // }
  if (!values.billingInformation?.billingAddress1) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.billingAddress1 = feildCannot;
  } else if (
    !oneAlphabetRegex?.test(values.billingInformation?.billingAddress1)
  ) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.billingAddress1 = letterRequired;
  } else if (values.billingInformation?.billingAddress1?.length > 50) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.billingAddress1 = invalidText;
  }
  if (!values.billingInformation?.billingAddress2) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.billingAddress2 = feildCannot;
  } else if (
    !oneAlphabetRegex?.test(values.billingInformation?.billingAddress2)
  ) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.billingAddress2 = letterRequired;
  } else if (values.billingInformation?.billingAddress2?.length > 50) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.billingAddress2 = invalidText;
  }
  if (!values.billingInformation?.country) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.country = feildCannot;
  }
  if (!values.billingInformation?.pincode) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.pincode = feildCannot;
  }
  if (!values.billingInformation?.city) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.city = feildCannot;
  }
  if (!values.billingInformation?.state) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.state = feildCannot;
  }
  if (!values.billingInformation?.gst_number) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.gst_number = feildCannot;
  } else if (!regex?.test(values.billingInformation?.gst_number)) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.gst_number = "Invali GST Number";
  }
  if (!values.billingInformation?.currency) {
    errors.billingInformation = errors.billingInformation || {};
    errors.billingInformation.currency = feildCannot;
  }
  return errors;
};
export const URLValidator = (values) => {
  let errors = {};
  // if (!values.urls) {
  //   errors.urls = feildCannot;
  // }
  return errors;
};
export const clientCourseValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};

  const today = new Date();
  const currentHours = today.getHours();
  const currentMinutes = today.getMinutes();

  if (!values.categories) {
    errors.categories = feildCannot;
  }
  if (!values.courseId) {
    errors.courseId = feildCannot;
  }
  if (!values.startDate) {
    errors.startDate = feildCannot;
  }
  if (!values.endDate) {
    errors.endDate = feildCannot;
  }
  if (!values.numberOfLicensesPurchased) {
    errors.numberOfLicensesPurchased = feildCannot;
  }
  if (!values.costPerLicences) {
    errors.costPerLicences = feildCannot;
  }
  if (values.licencesCostInfiation === "" || values.licencesCostInfiation === null || values.licencesCostInfiation === undefined) {
    errors.licencesCostInfiation = feildCannot;
  } else if (values.licencesCostInfiation > 99) {
    errors.licencesCostInfiation = "Invalid";
  }
  if (values.batchPurchase) {
    if (!values.batchSize) {
      errors.batchSize = feildCannot;
    } else if (values.batchSize < 0) {
      errors.batchSize = "Invalid batch size";
    }
    if (!values.cost_per_license2) {
      errors.cost_per_license2 = feildCannot;
    } else if (values.cost_per_license2 < 0) {
      errors.cost_per_license2 = "Invalid cost per license";
    }
  }
  if (!values.courseActivationDate) {
    errors.courseActivationDate = feildCannot;
  }
  if (!values.courseTime) {
    errors.courseTime = feildCannot;
  } else if (values.courseTime) {
    // Parse courseActivationDate as a Date object
    if (!values.courseActivated) {
      // Parse courseActivationDate as a Date object
      const activationDate = new Date(values.courseActivationDate);

      if (
        activationDate.toDateString() === today.toDateString() && // Check if it's today
        values.courseTime instanceof Date // Ensure courseTime is a Date object
      ) {
        // Get hours and minutes from courseTime
        const courseHours = values.courseTime.getHours();
        const courseMinutes = values.courseTime.getMinutes();

        // Validate courseTime
        if (
          courseHours < currentHours ||
          (courseHours === currentHours && courseMinutes < currentMinutes)
        ) {
          errors.courseTime =
            "Course time cannot be earlier than the current time.";
        }
      }
    }
  }
  if (values.languages?.length === 0) {
    errors.languages = feildCannot;
  }
  return errors;
};
export const industryValidator = (values) => {
  let errors = {};
  let namesSeen = new Set();
  if (values?.isUpload) {
    if (!values.fileName) {
      errors.fileName = feildCannot;
    }
  }
  values.data?.forEach((item, index) => {
    let itemErrors = {};

    if (!item.title) {
      itemErrors.title = "Field cannot be left blank.";
    } else {
      if (item.title.length > 50) {
        itemErrors.title = "Name is too long.";
      } else if (!oneAlphabetRegex?.test(item.title)) {
        itemErrors.title = letterRequired;
      }
      // Check for duplicate names
      if (namesSeen.has(item.title)) {
        itemErrors.title = "Duplicate title found.";
      } else {
        namesSeen.add(item.title);
      }
    }
    if (Object.keys(itemErrors).length > 0) {
      if (!errors.data) {
        errors.data = [];
      }
      errors.data[index] = itemErrors;
    }
  });
  console.log(errors, "learner val");
  return errors;
};
export const bulkDesigValidator = (values) => {
  let errors = {};
  let namesSeen = new Set();

  console.log(values, "bulkDesigValidator");

  values.data?.forEach((item, index) => {
    let itemErrors = {};

    if (!item.title) {
      itemErrors.title = "Field cannot be left blank.";
    } else {
      if (item.title.length > 50) {
        itemErrors.title = "Name is too long.";
      } else if (!oneAlphabetRegex?.test(item.title)) {
        itemErrors.title = letterRequired;
      }
      // Check for duplicate names
      if (namesSeen.has(item.title)) {
        itemErrors.title = "Duplicate title found.";
      } else {
        namesSeen.add(item.title);
      }
    }
    // if (!item.departmentId) {
    //   itemErrors.departmentId = feildCannot;
    // }
    if (Object.keys(itemErrors).length > 0) {
      if (!errors.data) {
        errors.data = [];
      }
      errors.data[index] = itemErrors;
    }
  });
  console.log(errors, "learner val");
  return errors;
};

const getExpectedMobileLength = (countryCode) => {
  const countryLengths = {
    "+91": 10, // India
    "+1": 10, // USA
    "+44": 10, // UK

    // Add more countries as needed
  };

  return countryLengths[countryCode] || 10; // Default to 10 if country not listed
};

export const learnerClientValidator = (values) => {
  let errors = {};
  let namesSeen = new Set();

  console.log(values, "values");
  if (values?.isUpload) {
    if (!values.fileName) {
      errors.fileUrl = feildCannot;
    }
    if (values.isUpload && values.isTable && values.isTableSingle) {
    }
  }
  if (values.isAdd) {
    values.data?.forEach((item, index) => {
      let itemErrors = {};

      // Validation logic for each item
      if (!item.name) {
        itemErrors.name = "Field cannot be left blank.";
      } else {
        if (item.name.length > 50) {
          itemErrors.name = "Name is too long.";
        } else if (!oneAlphabetRegex?.test(item.title)) {
          itemErrors.name = letterRequired;
        }
        // Check for duplicate names
        if (namesSeen.has(item.name)) {
          itemErrors.name = "Duplicate name found.";
        } else {
          namesSeen.add(item.name); // Add name to the set if not a duplicate
        }
      }
      if (!item.email) {
        itemErrors.email = feildCannot;
      } else if (checkEmail(item.email)) {
        itemErrors.email = "Invalid email format.";
      }
      if (item.mobileNumber) {
        if (item.mobileNumberCountryCode && item.mobileNumber) {
          // Find country data based on mobileCountryCode
          const countryData = countryValidationData?.find(
            (country) => country.dialCode === item.mobileNumberCountryCode
          );

          if (countryData) {
            // Validate the length of the mobile number
            if (item.mobileNumber?.length !== countryData?.length) {
              itemErrors.mobileNumber = `Invalid Mobile Number. It should be ${countryData.length} digits for ${countryData.country}.`;
            }
          }
        }
      }
      if (Object.keys(itemErrors).length > 0) {
        if (!errors.data) {
          errors.data = [];
        }
        errors.data[index] = itemErrors;
      }
    });
  }
  console.log(errors, "learner val");
  return errors;
};
export const learnerClientValidatorTwo = (values,isAddPass) => {
  let errors = {};
  let namesSeen = new Set();

  console.log(values, "values");
  if (values?.isUpload) {
    if (!values.fileName) {
      errors.fileUrl = feildCannot;
    }
    if (values.isUpload && values.isTable && values.isTableSingle) {
    }
    
  }
    if(isAddPass && !values.addPassword){
      errors.addPassword = feildCannot
    }
  if (values.isAdd) {
    values.data?.forEach((item, index) => {
      let itemErrors = {};

      // Validation logic for each item
      if (!item.name) {
        itemErrors.name = "Field cannot be left blank.";
      } else {
        if (item.name.length > 120) {
          itemErrors.name = "Name is too long.";
        } else if (!oneAlphabetRegex?.test(item.title)) {
          itemErrors.name = letterRequired;
        }
        // Check for duplicate names
        if (namesSeen.has(item.name)) {
          itemErrors.name = "Duplicate name found.";
        } else {
          namesSeen.add(item.name); // Add name to the set if not a duplicate
        }
      }
      if (!item.email) {
        itemErrors.email = feildCannot;
      } else if (checkEmail(item.email)) {
        itemErrors.email = "Invalid email format.";
      }
      // if (!item.clientLearnerId) {
      //   itemErrors.clientLearnerId = "Field cannot be left blank.";
      // }
      if (item.mobileNumber) {
        if (item.mobileNumberCountryCode && item.mobileNumber) {
          // Find country data based on mobileCountryCode
          const countryData = countryValidationData?.find(
            (country) => country.dialCode === item.mobileNumberCountryCode
          );

          if (countryData) {
            // Validate the length of the mobile number
            if (item.mobileNumber?.length !== countryData?.length) {
              itemErrors.mobileNumber = `Invalid Mobile Number. It should be ${countryData.length} digits for ${countryData.country}.`;
            }
          }
        }
      }
      if (Object.keys(itemErrors).length > 0) {
        if (!errors.data) {
          errors.data = [];
        }
        errors.data[index] = itemErrors;
      }
    });

  }
  if (!values.courseId) {
    errors.courseId = "Field cannot be left blank.";
  }
  if (values.languageId?.length === 0) {
    errors.languageId = "Field cannot be left blank.";
  }
  console.log(errors, "learner val");
  return errors;
};
export const leanreClientEditValidator = (values) => {
  let errors = {};
  if (!values.userName) {
    errors.userName = "Field cannot be left blank.";
  } else {
    if (values.userName.length > 120) {
      errors.userName = "Name is too long.";
    } else if (!oneAlphabetRegex?.test(values.userName)) {
      errors.userName = letterRequired;
    }
  }
  if (!values.email) {
    errors.email = feildCannot;
  } else if (checkEmail(values.email)) {
    errors.email = "Invalid email format.";
  }
  // if (!values.clientLearnerId) {
  //   errors.clientLearnerId = feildCannot;
  // }
  return errors;
};
export const comiteClientValidator = (values) => {
  let errors = {};
  if (!values.committeeName) {
    errors.committeeName = feildCannot;
  } else if (values.committeeName?.length > 50) {
    errors.committeeName = invalidText;
  } else if (!oneAlphabetRegex?.test(values.committeeName)) {
    errors.committeeName = letterRequired;
  }
  // if (!values.city) {
  //   errors.city = feildCannot;
  // } else

  if (values.city?.length > 50) {
    errors.city = invalidText;
  }
  if (values.city) {
    if (!oneAlphabetRegex?.test(values.city)) {
      errors.city = letterRequired;
    }
  }

  return errors;
};
export const memberValidator = (values) => {
  let errors = {};
  if (values.internal) {
    if (!values.name) {
      errors.name = feildCannot;
    } else if (values.name?.length > 50) {
      errors.name = invalidText;
    } else if (!oneAlphabetRegex?.test(values.name)) {
      errors.name = letterRequired;
    }
    if (values.countryCode && values.mobileNumber) {
      // Find country data based on mobileCountryCode
      const countryData = countryValidationData?.find(
        (country) => country.dialCode === values.countryCode
      );

      if (countryData) {
        // Validate the length of the mobile number
        if (values.mobileNumber?.length !== countryData?.length) {
          errors.mobileNumber = `Invalid Mobile Number. It should be ${countryData.length} digits for ${countryData.country}.`;
        }
      }
    }
  }
  if (values.external) {
    if (!values.nameTwo) {
      errors.nameTwo = feildCannot;
    } else if (values.nameTwo?.length > 50) {
      errors.nameTwo = invalidText;
    } else if (!oneAlphabetRegex?.test(values.nameTwo)) {
      errors.nameTwo = letterRequired;
    }
    if (!values.emailTwo) {
      errors.emailTwo = feildCannot;
    } else if (checkEmail(values.emailTwo)) {
      errors.emailTwo = "Invalid Email";
    }
    if (values.countryCodeTwo && values.mobileNumberTwo) {
      // Find country data based on mobileCountryCode
      const countryData = countryValidationData?.find(
        (country) => country.dialCode === values.countryCodeTwo
      );

      if (countryData) {
        // Validate the length of the mobile number
        if (values.mobileNumberTwo?.length !== countryData?.length) {
          errors.mobileNumberTwo = `Invalid Mobile Number. It should be ${countryData.length} digits for ${countryData.country}.`;
        }
      }
    }
  }
  // if (!values.mobileNumber) {
  //   errors.mobileNumber = feildCannot;
  // }

  // if (!values.city) {
  //   errors.city = feildCannot;
  // }
  // if (!values.designation) {
  //   errors.designation = feildCannot;
  // }
  console.log(errors, "errors errors");
  return errors;
};
export const policyClientValidator = (values) => {
  console.log(values, "policyClientValidator");
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (values.documents?.length === 0) {
    errors.documents = feildCannot;
  }

  return errors;
};

export const groupClientValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values?.title.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (values?.description.length > 500) {
    errors.description = "Character limit exceeded. Limit: 500 characters";
  }
  // if (values.categoriesIds?.length === 0) {
  //   errors.categoriesIds = feildCannot;
  // }
  // if (values.courseIds?.length === 0) {
  //   errors.courseIds = feildCannot;
  // }
  // if (values.industry?.length === 0) {
  //   errors.industry = feildCannot;
  // }
  // if (values.city?.length === 0) {
  //   errors.city = feildCannot;
  // }
  if (values.clientIds?.length === 0) {
    errors.clientIds = feildCannot;
  }
  return errors;
};
export const courseDeleteValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (values.courseIds?.length === 0) {
    errors.courseIds = feildCannot;
  }
  if (values.categorieIds?.length === 0) {
    errors.categorieIds = feildCannot;
  }
  return errors;
};
export const episodeDeleteValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (values.courseIds?.length === 0) {
    errors.courseIds = feildCannot;
  }
  if (values.categorieIds?.length === 0) {
    errors.categorieIds = feildCannot;
  }
  if (values.episodeIds?.length === 0) {
    errors.episodeIds = feildCannot;
  }
  if (values.languageIds?.length === 0) {
    errors.languageIds = feildCannot;
  }
  return errors;
};
export const learnerDeleteValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (values.clientIds?.length === 0) {
    errors.clientIds = feildCannot;
  }
  if (values.courseIds?.length === 0) {
    errors.courseIds = feildCannot;
  }
  if (values.categorieIds?.length === 0) {
    errors.categorieIds = feildCannot;
  }
  return errors;
};
export const departValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  }
  if (values.title?.length > 50) {
    errors.title = invalidText;
  }
  return errors;
};
export const profileValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (!values.firstName) {
    errors.firstName = feildCannot;
  }
  if (values.firstName?.length > 50) {
    errors.firstName = invalidText;
  }
  if (!values.lastName) {
    errors.lastName = feildCannot;
  }
  if (values.lastName?.length > 50) {
    errors.lastName = invalidText;
  }
  return errors;
};
export const passwordValidator = (values) => {
  let errors = {};
  if (!values.oldPassword) {
    errors.oldPassword = feildCannot;
  }
  if (!values.newPassword) {
    errors.newPassword = feildCannot;
  } else if (values.newPassword.length < 8) {
    errors.newPassword =
      "Password must contain 8 characters, at least one uppercase letter, one lowercase letter, one number and one special character";
  } else if (!passwordRegex.test(values.newPassword)) {
    errors.newPassword = "Invalid Password";
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = feildCannot;
  } else if (values.newPassword !== values.confirmPassword) {
    errors.confirmPassword = "Password does not match";
  }
  return errors;
};
export const surveyGroupValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (values.description?.length > 2000) {
    errors.description = "Character limit exceeded. Limit: 2000 characters";
  }
  return errors;
};
export const emailSendValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (!values.from) {
    errors.from = feildCannot;
  } else if (!oneAlphabetRegex?.test(values.from)) {
    errors.from = letterRequired;
  }
  if (values.sendTo?.length === 0) {
    errors.sendTo = feildCannot;
  }
  if (!values.subject) {
    errors.subject = feildCannot;
  }
  if (!values.body) {
    errors.body = feildCannot;
  }
  return errors;
};
export const designationValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  // if (!values.departmentId) {
  //   errors.departmentId = feildCannot;
  // }
  return errors;
};
export const bulkUploadValidator = (values) => {
  let errors = {};
  if (!values.fileName) {
    errors.fileName = feildCannot;
  }
  // if (!values.departmentId) {
  //   errors.departmentId = feildCannot;
  // }
  return errors;
};
export const surveyValidator = (values) => {
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (!values.surveyGroup) {
    errors.surveyGroup = feildCannot;
  }
  if (values.pllStatus) {
    const { name, email, organizationName } = values.markAsMandtory || {};

    // Check if at least one of the fields is true
    if (!name && !email && !organizationName) {
      errors.markAsMandtory =
        "At least one field (Name, Email, or Organization Name) must be checked.";
    }
  }

  if (values.description?.length > 2000) {
    errors.description = "Character limit exceeded. Limit: 2000 characters";
  }
  values.questions.forEach((question, questionIndex) => {
    let questionErrors = {};
    // Validate episode name
    if (!question.question) {
      questionErrors.question = `Field cannot be left blank`;
    } else if (!oneAlphabetRegex?.test(values.question)) {
      questionErrors.question = letterRequired;
    }
    if (!question.questionType) {
      questionErrors.questionType = feildCannot;
    }
    if (
      question.questionType === "single_choice" ||
      question.questionType === "description" ||
      question.questionType === "rating" ||
      question.questionType === "multiple_choice"
    ) {
      let questionValuesErrors = [];
      question.answerOptions.forEach((option, optionIndex) => {
        let optionErrors = {};
        if (!option.title) {
          optionErrors.title = `Field cannot be left blank`;
        }
        if (option.title?.length > 500) {
          optionErrors.title =
            "Character limit exceeded. Limit: 500 characters";
        } else if (!oneAlphabetRegex?.test(option.title)) {
          optionErrors.title = letterRequired;
        }
        if (Object.keys(optionErrors).length > 0) {
          questionValuesErrors[optionIndex] = optionErrors;
        }
      });
      if (questionValuesErrors.length > 0) {
        questionErrors.answerOptions = questionValuesErrors;
      }
    }

    // If there are any errors for the course, add them to the errors object.
    if (Object.keys(questionErrors).length > 0) {
      errors.questions = errors.questions || [];
      errors.questions[questionIndex] = questionErrors;
    }
  });
  console.log(values, "survey form validation");
  console.log(errors, "errors form validation");
  return errors;
};
export const trailerValidatore = (values) => {
  const errors = {};
  const fieldCannot = "This field cannot be empty";

  // Validate basic fields
  if (!values.translateCategory) errors.translateCategory = fieldCannot;
  else if (values.translateCategory?.length > 50) {
    errors.translateCategory = invalidText;
  } else if (!oneAlphabetRegex?.test(values.translateCategory)) {
    errors.translateCategory = letterRequired;
  }
  if (!values.translateCourseName) errors.translateCourseName = fieldCannot;
  else if (values.translateCourseName?.length > 50) {
    errors.translateCourseName = invalidText;
  } else if (!oneAlphabetRegex?.test(values.translateCourseName)) {
    errors.translateCourseName = letterRequired;
  }
  if (!values.baiseDescription || values.baiseDescription === "<p><br></p>")
    errors.baiseDescription = fieldCannot;
  else if (values.baiseDescription?.length > 2000)
    errors.baiseDescription =
      "Character limit exceeded. Limit: 2000 characters";
  if (!values.logoImage) errors.logoImage = fieldCannot;
  if (!values.bannerTrailerImageNameUrl)
    errors.bannerTrailerImageNameUrl = fieldCannot;
  if (!values.thumbnailImage) errors.thumbnailImage = fieldCannot;

  // Validate trailers
  if (values.trailers && values.trailers?.length > 0) {
    let trailersHaveErrors = false;
    const seenTitles = new Set();

    const trailerErrors = values.trailers?.map((trailer) => {
      const trailerError = {};
      // Assuming 'title' is required for each trailer
      if (!trailer.title) {
        trailersHaveErrors = true;
        trailerError.title = "Title is required";
      } else {
        // Check for duplicate titles
        if (seenTitles.has(trailer.title)) {
          trailersHaveErrors = true;
          trailerError.title = "Duplicate title found";
        } else {
          seenTitles.add(trailer.title);
        }

        // Check for title length
        if (trailer.title?.length > 50) {
          trailersHaveErrors = true;
          trailerError.title = invalidText;
        }
      }
      if (trailer.description && trailer.description?.length > 200) {
        trailersHaveErrors = true;
        trailerError.description =
          "Character limit exceeded. Limit: 200 characters";
      }

      return trailerError;
    });

    // Only add trailer errors if any were found
    if (trailersHaveErrors) {
      errors.trailers = trailerErrors;
    }
  } else {
    // Set an error if no trailers are provided
    errors.trailers = ["At least one trailer must be provided"];
  }

  // if (values.trailers && values.trailers.length > 0) {
  //   let trailerErrors = values.trailers.map((trailer) => {
  //     const trailerError = {};
  //     if (!trailer.title) {
  //       trailerError.title = "This field cannot be empty"; // Custom message per trailer
  //     }
  //     return trailerError;
  //   });

  //   // Filter out any empty error objects to avoid React rendering issues
  //   trailerErrors = trailerErrors.filter(
  //     (error) => Object.keys(error).length > 0
  //   );

  //   if (trailerErrors.length > 0) {
  //     errors.trailers = trailerErrors;
  //   }
  // } else {
  //   // Set an error if no trailers are provided
  //   errors.trailers = ["At least one trailer must be provided"]; // Ensure this is an array with strings
  // }

  console.log(errors, "errors  errors errorserrors");
  return errors;
};

export const courseEpisodeValidatore = (values) => {
  console.log(values, "courseEpisodeValidatore");
  let errors = {};
  if (!values?.courseEpisodeeName) {
    errors.courseEpisodeeName = feildCannot;
  } else if (values?.courseEpisodeeName?.length > 50) {
    errors.courseEpisodeeName = invalidText;
  } else if (!oneAlphabetRegex?.test(values.courseEpisodeeName)) {
    errors.courseEpisodeeName = letterRequired;
  }
  // if (values?.courseTags?.length === 0) {
  //   errors.courseTags = feildCannot;
  // }
  if (values?.courseDescription?.length > 2000) {
    errors.courseDescription =
      "Character limit exceeded. Limit: 2000 characters";
  }
  if (values?.courseEpisodes?.length === 0) {
    errors.courseEpisodes = feildCannot;
  }
  if (!values?.url) {
    errors.url = feildCannot;
  }

  const minutesNum = Number(values.minutes);
  const secondsNum = Number(values.seconds);
  const minutesNumMusic = Number(values.minutesMusic);
  const secondsNumMusic = Number(values.secondsMusic);
  const minTimeNum = Number(values.minTime);
  const secTimeNum = Number(values.secTime);

  if (values.placementType === 2) {
    if (!values.seconds) {
      errors.seconds = "Required";
    }
    if (minutesNum > minTimeNum) {
      errors.minutes = `Minutes should not exceed ${minTimeNum}`;
    } else if (minutesNum === minTimeNum && secondsNum > secTimeNum) {
      errors.seconds = `Seconds should not exceed ${secTimeNum} when minutes are set to the maximum allowed`;
    }

    const duplicateTime = values.combineVideoMusic?.some((video) => {
      return (
        Number(video.minutes) === minutesNum &&
        Number(video.seconds) === secondsNum
      );
    });

    if (duplicateTime) {
      errors.seconds = "This time is already scheduled in another File";
    }
  }
  if (values.placementTypeMusic === 2) {
    if (!values.secondsMusic) {
      errors.secondsMusic = "Required";
    }
    if (minutesNumMusic > minTimeNum) {
      errors.minutesMusic = `Minutes should not exceed ${minTimeNum}`;
    } else if (minutesNumMusic === minTimeNum && secondsNumMusic > secTimeNum) {
      errors.secondsMusic = `Seconds should not exceed ${secTimeNum} when minutes are set to the maximum allowed`;
    }

    const duplicateTime = values.combineVideoMusic?.some((video) => {
      return (
        Number(video.minutes) === minutesNumMusic &&
        Number(video.seconds) === secondsNumMusic
      );
    });

    if (duplicateTime) {
      errors.secondsMusic = "This time is already scheduled in another File";
    }
  }
  console.log(errors, "APpend Video Validatore");
  return errors;
};

// export const clientQuizzInterLangValidator = (values) => {
//   let errors = {};

//   if (values.questions?.length > 0) {
//     let questionsErrors = [];

//     values.questions.forEach((question, questionIndex) => {
//       let questionErrors = {};
//       const minTimeNum = Number(question.minTime);
//       const secTimeNum = Number(question.secTime);

//       if (!question.question) {
//         questionErrors.question = "Field cannot be left blank.";
//       }

//       const minutesNum = Number(question.minutes);
//       if (!question.minutes) {
//         questionErrors.minutes = "Minutes are required";
//       } else if (
//         isNaN(minutesNum) || minutesNum < 0 || minutesNum > 59 || !Number.isInteger(minutesNum)
//       ) {
//         questionErrors.minutes = "Invalid minutes value";
//       } else if (minutesNum > minTimeNum) {
//         questionErrors.minutes = `Minutes should not exceed ${minTimeNum}`;
//       }

//       const secondsNum = Number(question.seconds);
//       if (!question.seconds) {
//         questionErrors.seconds = "Seconds are required";
//       } else if (
//         isNaN(secondsNum) || secondsNum < 0 || secondsNum > 59 || !Number.isInteger(secondsNum)
//       ) {
//         questionErrors.seconds = "Invalid seconds value";
//       } else if (minutesNum === minTimeNum && secondsNum > secTimeNum) {
//         questionErrors.seconds = `Seconds should not exceed ${secTimeNum} when minutes are set to the maximum allowed`;
//       }

//       if (questionIndex > 0) {
//         const prevQuestion = values.questions[questionIndex - 1];
//         if (
//           Number(prevQuestion.minutes) === minutesNum &&
//           Number(prevQuestion.seconds) === secondsNum
//         ) {
//           questionErrors.minutes = "Current question's time cannot be the same as the previous question's time.";
//         }
//       }

//       if (Object.keys(questionErrors).length > 0) {
//         questionsErrors[questionIndex] = questionErrors;
//       }
//     });

//     if (questionsErrors.length > 0) {
//       errors.questions = questionsErrors;
//     }
//   }

//   console.log(errors, "errors")
//   return errors;
// };

export const clientQuizzInterLangValidator = (values) => {
  console.log(values, "Client interactive");
  let errors = {};

  if (values.questions?.length > 0) {
    let questionsErrors = [];

    const minTimeNum = Number(values.minTime);
    const secTimeNum = Number(values.secTime);
    values.questions?.forEach((question, questionIndex) => {
      let questionErrors = {};

      // Question text validation
      if (!question.question) {
        questionErrors.question = "Field cannot be left blank.";
      } else if (!oneAlphabetRegex?.test(question.question)) {
        questionErrors.question = letterRequired;
      } else if (question.answerOptions?.length < 2) {
        questionErrors.question = `Question should have minimum 2 options`;
      }

      const minutesNum = Number(question.minutes);
      const secondsNum = Number(question.seconds);

      console.log(
        { minutesNum, minTimeNum, secondsNum, secTimeNum },
        " same tame "
      );

      // Minutes validation only if minTime is greater than 0
      if (minTimeNum > 0) {
        if (
          isNaN(minutesNum) ||
          minutesNum < 0 ||
          minutesNum > 59 ||
          !Number.isInteger(minutesNum)
        ) {
          questionErrors.minutes = "Invalid minutes value";
        } else if (minutesNum > minTimeNum) {
          questionErrors.minutes = `Minutes should not exceed ${minTimeNum}`;
        }
      }

      // Seconds validation
      if (!question.minutes) {
        if (!question.seconds) {
          questionErrors.seconds = "Required";
        }
      } else if (
        isNaN(secondsNum) ||
        secondsNum < 0 ||
        secondsNum > 59 ||
        !Number.isInteger(secondsNum)
      ) {
        questionErrors.seconds = "Invalid seconds value";
      } else if (minutesNum === minTimeNum && secondsNum > secTimeNum) {
        questionErrors.seconds = `Seconds should not exceed ${secTimeNum} when minutes are set to the maximum allowed`;
      }

      // Checking for duplicate times
      if (questionIndex > 0) {
        const prevQuestion = values.questions[questionIndex - 1];
        if (
          Number(prevQuestion.minutes) === minutesNum &&
          Number(prevQuestion.seconds) === secondsNum
        ) {
          questionErrors.minutes =
            "Current question's time cannot be the same as the previous question's time.";
        }
      }

      question?.answerOptions?.forEach((value, valueIndex) => {
        if (!value.option) {
          if (!questionErrors.answerOptions) {
            questionErrors.answerOptions = [];
          }
          questionErrors.answerOptions[valueIndex] = {
            option: `Field cannot be left blank`,
          };
        }
      });

      // Collecting errors
      if (Object.keys(questionErrors).length > 0) {
        questionsErrors[questionIndex] = questionErrors;
      }
    });

    // Setting errors for questions
    if (questionsErrors.length > 0) {
      errors.questions = questionsErrors;
    }
  }

  console.log(errors); // For debugging purposes
  return errors;
};
export const SpecialCertificatessValidator = (values) => {
  // console.log(values, "courseValidator");
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (!values.certificateTitle) {
    errors.certificateTitle = feildCannot;
  } else if (values.certificateTitle?.length > 50) {
    errors.certificateTitle = invalidText;
  } else if (!oneAlphabetRegex?.test(values.certificateTitle)) {
    errors.certificateTitle = letterRequired;
  }
  if (!values.clientName) {
    errors.clientName = feildCannot;
  } else if (values.clientName?.length > 50) {
    errors.clientName = invalidText;
  } else if (!oneAlphabetRegex?.test(values.clientName)) {
    errors.clientName = letterRequired;
  }
  if (!values.companyName) {
    errors.companyName = feildCannot;
  } else if (values.companyName?.length > 50) {
    errors.companyName = invalidText;
  } else if (!oneAlphabetRegex?.test(values.companyName)) {
    errors.companyName = letterRequired;
  }
  if (!values.templateId) {
    errors.templateId = feildCannot;
  }
  if (!values.certificateText) {
    errors.certificateText = feildCannot;
  }
  if (values.isMannual) {
    if (!values.issueDate) {
      errors.issueDate = feildCannot;
    }
  }
  if (values.clientLogoStatus) {
    if (!values.clientLogoUrl) {
      errors.clientLogoUrl = feildCannot;
    }
  }
  if (values.clientSigatoryStatus) {
    if (!values.clientSigatoryUrl) {
      errors.clientSigatoryUrl = feildCannot;
    }
  }
  if (values.status === "sendEmail") {
    if (!values.subject) {
      errors.subject = feildCannot;
    }
    if (values.sendTo?.length === 0) {
      errors.sendTo = feildCannot;
    }
    if (!values.body) {
      errors.body = feildCannot;
    }
  }
  if (values.isUploadLearner) {
    if (!values.fileUrl) {
      errors.fileUrl = feildCannot;
    }
  }

  console.log(errors);
  return errors;
};
export const ClientAdminSPOCValidator = (values) => {
  let errors = {};
  if (!values.firstName) {
    errors.firstName = feildCannot;
  } else if (values.firstName?.length > 50) {
    errors.firstName = invalidText;
  } else if (!oneAlphabetRegex?.test(values.firstName)) {
    errors.firstName = letterRequired;
  }
  // if (!values.lastName) {
  //   errors.lastName = feildCannot;
  // }
  if (values.lastName?.length > 50) {
    errors.lastName = invalidText;
  }
  // else if (!oneAlphabetRegex?.test(values.lastName)) {
  //   errors.lastName = letterRequired;
  // }
  if (!values.email) {
    errors.email = feildCannot;
  } else if (checkEmail(values.email)) {
    errors.email = "Invalid Email";
  } else if (values.email?.length > 50) {
    errors.email = invalidText;
  }
  if (values.mobileCountryCode && values.mobileNumber) {
    // Find country data based on mobileCountryCode
    const countryData = countryValidationData?.find(
      (country) => country.dialCode === values.mobileCountryCode
    );

    if (countryData) {
      // Validate the length of the mobile number
      if (values.mobileNumber?.length !== countryData?.length) {
        errors.mobileNumber = `Invalid Mobile Number. It should be ${countryData.length} digits for ${countryData.country}.`;
      }
    }
  }
  if (!values.userType) {
    errors.userType = feildCannot;
  }
  if (values.courseIds?.length === 0) {
    errors.courseIds = feildCannot;
  }
  return errors;
};
export const companyDetailsValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (!values.organization_name) {
    errors.organization_name = feildCannot;
  } else if (values.organization_name?.length > 50) {
    errors.organization_name = invalidText;
  } else if (!oneAlphabetRegex?.test(values.organization_name)) {
    errors.organization_name = letterRequired;
  }
  if (!values.GST_number) {
    errors.GST_number = feildCannot;
  } else if (!regex?.test(values.GST_number)) {
    errors.GST_number = "Invali GST Number";
  }
  return errors;
};
export const templateValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (!values.title) {
    errors.title = feildCannot;
  } else if (values.title?.length > 50) {
    errors.title = invalidText;
  } else if (!oneAlphabetRegex?.test(values.title)) {
    errors.title = letterRequired;
  }
  if (!values.body) {
    errors.body = feildCannot;
  }
  return errors;
};
export const companyValidator = (values) => {
  console.log(values, "courseValidator");
  let errors = {};
  if (!values.organization_name) {
    errors.organization_name = feildCannot;
  }
  if (values.organization_name?.length > 50) {
    errors.organization_name = invalidText;
  }
  if (!values.info_contact_number) {
    errors.info_contact_number = feildCannot;
  }
  if (values.info_contact_number?.length > 50) {
    errors.info_contact_number = invalidText;
  }
  if (!values.address_line1) {
    errors.address_line1 = feildCannot;
  }
  if (values.address_line1?.length > 50) {
    errors.address_line1 = invalidText;
  }
  if (!values.country) {
    errors.country = feildCannot;
  }
  if (!values.organization_name) {
    errors.organization_name = feildCannot;
  }
  if (!values.pin_code) {
    errors.pin_code = feildCannot;
  }
  if (!values.pin_code) {
    errors.pin_code = feildCannot;
  }
  if (!values.city) {
    errors.city = feildCannot;
  }
  if (!values.state) {
    errors.state = feildCannot;
  }
  if (!values.GST_number) {
    errors.GST_number = feildCannot;
  } else if (!regex?.test(values.GST_number)) {
    errors.GST_number = "Invali GST Number";
  }
  return errors;
};
export const resolveValidator = (values) => {
  console.log(values, "resolveValidator");
  let errors = {};
  if (!values.resolveText) {
    errors.resolveText = feildCannot;
  }
  return errors;
};
